"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderType = exports.LitNetwork = exports.AuthMethodScope = exports.StakingStates = exports.AuthMethodType = exports.LIT_CURVE = exports.VMTYPE = void 0;
/** ---------- Chains ---------- */
var VMTYPE;
(function (VMTYPE) {
    VMTYPE["EVM"] = "EVM";
    VMTYPE["SVM"] = "SVM";
    VMTYPE["CVM"] = "CVM";
})(VMTYPE = exports.VMTYPE || (exports.VMTYPE = {}));
var LIT_CURVE;
(function (LIT_CURVE) {
    LIT_CURVE["BLS"] = "BLS";
    LIT_CURVE["EcdsaK256"] = "K256";
    LIT_CURVE["EcdsaCaitSith"] = "ECDSA_CAIT_SITH";
    LIT_CURVE["EcdsaCAITSITHP256"] = "EcdsaCaitSithP256";
})(LIT_CURVE = exports.LIT_CURVE || (exports.LIT_CURVE = {}));
/**
 * Supported PKP auth method types
 */
var AuthMethodType;
(function (AuthMethodType) {
    AuthMethodType[AuthMethodType["EthWallet"] = 1] = "EthWallet";
    AuthMethodType[AuthMethodType["LitAction"] = 2] = "LitAction";
    AuthMethodType[AuthMethodType["WebAuthn"] = 3] = "WebAuthn";
    AuthMethodType[AuthMethodType["Discord"] = 4] = "Discord";
    AuthMethodType[AuthMethodType["Google"] = 5] = "Google";
    AuthMethodType[AuthMethodType["GoogleJwt"] = 6] = "GoogleJwt";
    AuthMethodType[AuthMethodType["AppleJwt"] = 8] = "AppleJwt";
    AuthMethodType[AuthMethodType["StytchOtp"] = 9] = "StytchOtp";
    AuthMethodType[AuthMethodType["StytchEmailFactorOtp"] = 10] = "StytchEmailFactorOtp";
    AuthMethodType[AuthMethodType["StytchSmsFactorOtp"] = 11] = "StytchSmsFactorOtp";
    AuthMethodType[AuthMethodType["StytchWhatsAppFactorOtp"] = 12] = "StytchWhatsAppFactorOtp";
    AuthMethodType[AuthMethodType["StytchTotpFactorOtp"] = 13] = "StytchTotpFactorOtp";
})(AuthMethodType = exports.AuthMethodType || (exports.AuthMethodType = {}));
var StakingStates;
(function (StakingStates) {
    StakingStates[StakingStates["Active"] = 0] = "Active";
    StakingStates[StakingStates["NextValidatorSetLocked"] = 1] = "NextValidatorSetLocked";
    StakingStates[StakingStates["ReadyForNextEpoch"] = 2] = "ReadyForNextEpoch";
    StakingStates[StakingStates["Unlocked"] = 3] = "Unlocked";
    StakingStates[StakingStates["Paused"] = 4] = "Paused";
    StakingStates[StakingStates["Restore"] = 5] = "Restore";
})(StakingStates = exports.StakingStates || (exports.StakingStates = {}));
var AuthMethodScope;
(function (AuthMethodScope) {
    AuthMethodScope[AuthMethodScope["NoPermissions"] = 0] = "NoPermissions";
    AuthMethodScope[AuthMethodScope["SignAnything"] = 1] = "SignAnything";
    AuthMethodScope[AuthMethodScope["PersonalSign"] = 2] = "PersonalSign";
})(AuthMethodScope = exports.AuthMethodScope || (exports.AuthMethodScope = {}));
var LitNetwork;
(function (LitNetwork) {
    LitNetwork["Cayenne"] = "cayenne";
    LitNetwork["Manzano"] = "manzano";
    LitNetwork["Habanero"] = "habanero";
    LitNetwork["Custom"] = "custom";
    LitNetwork["DatilDev"] = "datil-dev";
    LitNetwork["DatilTest"] = "datil-test";
    LitNetwork["Datil"] = "datil";
})(LitNetwork = exports.LitNetwork || (exports.LitNetwork = {}));
/**
 * Supported provider types
 */
var ProviderType;
(function (ProviderType) {
    ProviderType["Discord"] = "discord";
    ProviderType["Google"] = "google";
    ProviderType["EthWallet"] = "ethwallet";
    ProviderType["WebAuthn"] = "webauthn";
    ProviderType["Apple"] = "apple";
    ProviderType["StytchOtp"] = "stytchOtp";
    ProviderType["StytchEmailFactorOtp"] = "stytchEmailFactorOtp";
    ProviderType["StytchSmsFactorOtp"] = "stytchSmsFactorOtp";
    ProviderType["StytchWhatsAppFactorOtp"] = "stytchWhatsAppFactorOtp";
    ProviderType["StytchTotpFactor"] = "stytchTotpFactor";
})(ProviderType = exports.ProviderType || (exports.ProviderType = {}));
//# sourceMappingURL=enums.js.map